import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ShoppingCartIcon, SearchIcon, MenuIcon, XIcon } from 'lucide-react';
import { CartContext } from '../App';
export function Header() {
  const [searchQuery, setSearchQuery] = useState('');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const {
    cart
  } = useContext(CartContext);
  const totalItems = cart.reduce((total, item) => total + item.quantity, 0);
  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real app, this would navigate to search results
    console.log('Searching for:', searchQuery);
    setSearchQuery('');
  };
  return <header className="bg-white shadow-sm sticky top-0 z-10" data-id="element-64">
      <div className="container mx-auto px-4 py-4" data-id="element-65">
        <div className="flex items-center justify-between" data-id="element-66">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-id="element-67">
            <span className="text-2xl font-bold text-green-600" data-id="element-68">EcoTech</span>
            <span className="text-sm text-gray-500 ml-1" data-id="element-69">Market</span>
          </Link>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-70">
            <Link to="/" className="text-gray-700 hover:text-green-600 transition" data-id="element-71">
              Home
            </Link>
            <Link to="/#electronics" className="text-gray-700 hover:text-green-600 transition" data-id="element-72">
              Electronics
            </Link>
            <Link to="/#metals" className="text-gray-700 hover:text-green-600 transition" data-id="element-73">
              Precious Metals
            </Link>
          </nav>
          {/* Search Bar */}
          <div className="hidden md:block flex-grow max-w-md mx-4" data-id="element-74">
            <form onSubmit={handleSearch} className="relative" data-id="element-75">
              <input type="text" placeholder="Search products..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full py-2 px-4 pr-10 border border-gray-300 rounded-full focus:outline-none focus:ring-1 focus:ring-green-500" data-id="element-76" />
              <button type="submit" className="absolute right-3 top-2.5 text-gray-400 hover:text-green-600" data-id="element-77">
                <SearchIcon size={18} data-id="element-78" />
              </button>
            </form>
          </div>
          {/* Cart Icon */}
          <Link to="/cart" className="relative ml-4" data-id="element-79">
            <ShoppingCartIcon size={24} className="text-gray-700 hover:text-green-600 transition" data-id="element-80" />
            {totalItems > 0 && <span className="absolute -top-2 -right-2 bg-green-600 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center" data-id="element-81">
                {totalItems}
              </span>}
          </Link>
          {/* Mobile Menu Button */}
          <button className="md:hidden ml-4 text-gray-700" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-82">
            {mobileMenuOpen ? <XIcon size={24} data-id="element-83" /> : <MenuIcon size={24} data-id="element-84" />}
          </button>
        </div>
        {/* Mobile Search Bar */}
        <div className="mt-4 md:hidden" data-id="element-85">
          <form onSubmit={handleSearch} className="relative" data-id="element-86">
            <input type="text" placeholder="Search products..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full py-2 px-4 pr-10 border border-gray-300 rounded-full focus:outline-none focus:ring-1 focus:ring-green-500" data-id="element-87" />
            <button type="submit" className="absolute right-3 top-2.5 text-gray-400 hover:text-green-600" data-id="element-88">
              <SearchIcon size={18} data-id="element-89" />
            </button>
          </form>
        </div>
        {/* Mobile Menu */}
        {mobileMenuOpen && <nav className="md:hidden mt-4 pb-2 space-y-3" data-id="element-90">
            <Link to="/" className="block py-2 text-gray-700 hover:text-green-600" onClick={() => setMobileMenuOpen(false)} data-id="element-91">
              Home
            </Link>
            <Link to="/#electronics" className="block py-2 text-gray-700 hover:text-green-600" onClick={() => setMobileMenuOpen(false)} data-id="element-92">
              Electronics
            </Link>
            <Link to="/#metals" className="block py-2 text-gray-700 hover:text-green-600" onClick={() => setMobileMenuOpen(false)} data-id="element-93">
              Precious Metals
            </Link>
          </nav>}
      </div>
    </header>;
}